import { Closure } from "@/model/Closure";

export class Zone {
    zoneCode: string;
    zoneLabel: string
    emails: string[];
    closures: Closure[];
    enabled: boolean = false;
}